import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {QuoteType} from "../../types/quote.type";

export class DispatchQuoteTypesMultiSelectListComponent implements IController {

  dispatchQuoteTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: string;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(QuoteType);
    }
  }

  $onChanges(changes) {
    if (changes.dispatchQuoteTypes) {
      this.selectedKeys = [];
      _.forEach(this.dispatchQuoteTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      dispatchQuoteTypes: isSelected ? _.concat(this.dispatchQuoteTypes, [option]) :
        _.filter(this.dispatchQuoteTypes, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({dispatchQuoteTypes: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('dispatchQuoteTypesMultiSelect', {
    bindings: {
      dispatchQuoteTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./dispatch-quote-types-multi-select-list.html').default,
    controller: DispatchQuoteTypesMultiSelectListComponent
  });
